import { useEffect, useRef } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

export default function LocationMap({ coords, onCoordsChange }) {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (mapInstance.current) return;

    const map = new maplibregl.Map({
      container: mapRef.current,
      style: "/mapStyle.json",
      center: [-65, -40],
      zoom: 3.5,
    });

    mapInstance.current = map;

    map.on("click", (e) => {
      const { lng, lat } = e.lngLat;

      moveMarker(lat, lng);
      onCoordsChange?.({ lat, lng });
    });
  }, [onCoordsChange]);

  useEffect(() => {
    if (!coords || !mapInstance.current) return;
    moveMarker(coords.lat, coords.lng);
  }, [coords]);

  function moveMarker(lat, lng) {
    const map = mapInstance.current;

    map.flyTo({
      center: [lng, lat],
      zoom: 15,
    });

    if (!markerRef.current) {
      markerRef.current = new maplibregl.Marker({ draggable: false })
        .setLngLat([lng, lat])
        .addTo(map);
    } else {
      markerRef.current.setLngLat([lng, lat]);
    }
  }

  return <div ref={mapRef} className="w-full h-full" />;
}
